import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import EditorImg from 'lowcode/components/EditorImg';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { useDP3Store } from '../../DP3Provider';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { gtm } = useGlobal();
    const { pageStatus } = useDP3Store();
    const { locale = 'us' } = useRouter();
    const isTEASER = pageStatus === IPageStatus.statusA;
    const idObj: any = {
        jp: '#dp3-SubscribeA',
        us: '#dp3-teaser-B',
    };
    const idHref = idObj[locale] || idObj.us;
    const TEXT_MAP: any = {
        jp: '今すぐ登録',
        us: 'Sign Up\nNow!',
    };
    const textTeaser = TEXT_MAP[locale] || TEXT_MAP.us;

    // 众筹
    const TEXT_MAP2: any = {
        jp: '今すぐ登録',
        us: 'Get up to $250 Cashback When You Refer A Friend!',
    };
    const textCrowdfunding = TEXT_MAP2[locale] || TEXT_MAP2.us;
    // 最后选择
    const textLast = isTEASER ? textTeaser : textCrowdfunding;
    const [closeFlag, setCloseFlag] = useState(false);
    const closeHandle = () => {
        setCloseFlag(true);
    };

    const handleClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: 'EcoFlow DELTA Pro 3',
        });
        return true;
    };

    return (
        <div className={`${css.thecomp} pageStatus-${pageStatus} GtmModuleData-section`} data-section-id={'dp3-BarIconR'} data-section-title={'dp3-BarIconR'}>
            <div className={`BarIconR-in ${closeFlag ? ' BarIconR-in-close' : ''}`}>
                <a
                    onClick={handleClick}
                    href={`https://www.ecoflow.com/${locale}/referral-delta-pro-3-portable-power-station`}
                    className={`BarIconR-in-link`}
                    target="blank"
                >
                    <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719050250908/bb1.png" />
                </a>

                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={closeHandle} className="BarIconR-close">
                    <g id="close">
                        <circle id="Ellipse 708" cx="6" cy="6" r="6" fill="#999999" />
                        <path
                            id="Union"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.91207 4.5182C8.0878 4.34246 8.0878 4.05754 7.91207 3.8818C7.73633 3.70607 7.45141 3.70607 7.27567 3.8818L5.89699 5.26048L4.51832 3.8818C4.34258 3.70607 4.05766 3.70607 3.88192 3.8818C3.70618 4.05754 3.70618 4.34246 3.88192 4.5182L5.2606 5.89688L3.88156 7.27591C3.70582 7.45165 3.70582 7.73657 3.88156 7.91231C4.05729 8.08805 4.34222 8.08805 4.51795 7.91231L5.89699 6.53327L7.27603 7.91231C7.45177 8.08805 7.73669 8.08805 7.91243 7.91231C8.08816 7.73657 8.08816 7.45165 7.91243 7.27591L6.53339 5.89687L7.91207 4.5182Z"
                            fill="white"
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};

export default TheComp;
